import styled from "@emotion/styled";

export const Base = styled.p`
  color: #ff1818;
  font-size: 0.8rem;
`;
